import { Component, h } from 'preact'
import axios from 'axios'
import { t } from '../../libs/translationsUtils/translations'
import tracker from '../../components/tracker/publish'
import { getCurrentPage } from '../common/index'
import Analytics from '../analytics/Analytics'
import { z } from 'zod'
import { GetServerSideProps } from '../../server-middleware/context'
import BoxWidget from '../../components/box-widget'

const eventTracker = () => {
  tracker.trackEvent('userevent', {
    type: 'Sidebar Widget Clicked',
    widget: 'solved topics',
    click_source: getCurrentPage()
  })

  if (getCurrentPage() === 'homepage') {
    Analytics.send('Homepage', 'Widget clicked', {
      Type: 'Solved topics'
    })
  }
}

interface Topic {
  title: string
  url: string
  numberOfReplies: number
  lastPost: {
    url: string
  }
}

interface Props {
  title: string
  query: {
    maxResults: string
    minReplies: number
    prefixIds: string[]
    sort: string
    sortOrder: string
  }
}

interface State {
  topics: Topic[]
}

export const widgetName = 'solved_topics'

export const config = z.object({
  title: z.string(),
  query: z.object({
    maxResults: z.string(),
    minReplies: z.number(),
    prefixIds: z.array(z.string()),
    sort: z.string(),
    sortOrder: z.string()
  })
})

type Config = z.infer<typeof config>

export const getServerSideProps: GetServerSideProps<Config, Props> = async (_, config) => {
  return {
    title: config.title,
    query: config.query
  }
}

export default class SolvedTopics extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      topics: []
    }
  }

  async componentDidMount () {
    const { data } = await axios.get('/widget/solvedTopics', {
      params: {
        query: JSON.stringify(this.props.query)
      }
    })

    this.setState({ topics: data })
  }

  render ({ title }: Props, { topics }: State) {
    if (!topics.length) {
      return null
    }
    return (
      <BoxWidget className='widget--solved-topics' contentClassName='widget-solvedtopics'>
        {title ? <h3 className='widget-title'>{title}</h3> : ''}
        <ul className='list simple-topic-list' onClick={eventTracker}>
          {
            topics.map((topic, i) => {
              return (
                <li key={i} class='simple-topic-list--item'>
                  <h6 class='simple-topic-list--title'>
                    <a className='link link--topic' href={topic.url}>{topic.title}</a>
                    <span className='icon icon--round icon--checkmark text--success qa-icon-answered' />
                  </h6>
                  <a href={topic.lastPost.url} className='text--meta'>{topic.numberOfReplies} {t('Forum', 'Reply', { value: topic.numberOfReplies.toString() })}</a>
                </li>
              )
            })
          }
        </ul>
      </BoxWidget>
    )
  }
}
